import React from 'react';
import { motion, useInView } from 'framer-motion';

/**
 * ScrollReveal - A reusable component for scroll-triggered animations
 * Provides smooth, professional animations when elements enter the viewport
 */
const ScrollReveal = ({ 
  children, 
  delay = 0, 
  direction = 'up',
  duration = 0.6,
  className = '',
  once = true
}) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { 
    once, 
    amount: 0.2,
    margin: "-50px"
  });

  // Animation variants based on direction
  const variants = {
    hidden: {
      opacity: 0,
      y: direction === 'up' ? 40 : direction === 'down' ? -40 : 0,
      x: direction === 'left' ? 40 : direction === 'right' ? -40 : 0,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1,
      transition: {
        type: "spring",
        damping: 25,
        stiffness: 120,
        duration,
        delay,
      }
    }
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={variants}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
